<template>
  <v-row>
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>

    <v-dialog v-model="changeInventoryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="changeInventory-btn mt-3">
            <center>
              <v-btn color="success" class="m-1" @click="openEntryDialog()"
                >رسید - افزایش موجودی</v-btn
              >
              <v-btn
                color="red"
                class="text-light m-1"
                @click="openExitDialog()"
                >حواله – کاهش موجودی</v-btn
              >
            </center>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="entryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>رسید - افزایش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ ورود">
              <date-picker v-model="entry.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group label="ساعت ورود">
              <date-picker
                v-model="entry.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <!-- <v-select
              label="انبار مقصد"
              :items="warehouses"
              v-model="entry.warehouse"
              outlined
              dense
              item-text="name"
              item-value="id"
            /> -->
            <v-autocomplete
              label="انبار مقصد"
              v-model="entry.warehouse"
              :items="warehouses"
              outlined
              dense
              item-text="name"
              item-value="id"
            >
            </v-autocomplete>
            <v-text-field
              outlined
              dense
              label="حجم ورودی"
              v-model="entry.number"
              type="number"
            ></v-text-field>
            <v-select
              v-model="entrySelectedType"
              dense
              outlined
              hide-details
              label="نوع رسید"
              :items="entryType"
              attach
              class="mb-3"
            >
            </v-select>
            <v-text-field
              outlined
              dense
              label="مبدا"
              v-model="entry.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="entry.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="entryDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="entrySubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exitDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>حواله - کاهش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ خروج">
              <date-picker v-model="exit.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group label="ساعت ورود">
              <date-picker
                v-model="exit.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <!-- <v-select
              label="انبار مبدا"
              :items="warehouses"
              v-model="exit.warehouse"
              outlined
              dense
              item-text="name"
              item-value="id"
            /> -->
            <v-autocomplete
              label="انبار مبدا"
              v-model="exit.warehouse"
              :items="warehouses"
              outlined
              dense
              item-text="name"
              item-value="id"
            >
            </v-autocomplete>
            <v-text-field
              outlined
              dense
              label="حجم خروجی"
              v-model="exit.number"
              type="number"
            ></v-text-field>
            <v-select
              v-model="exitSelectedType"
              dense
              outlined
              hide-details
              label="نوع حواله"
              :items="exitType"
              attach
              class="mb-3"
            >
            </v-select>
            <v-text-field
              outlined
              dense
              label="مقصد"
              v-model="exit.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="exit.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="exitDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="exitSubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="شرح فارسی *"
              v-model="selected2.identifierFa"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="شرح انگلیسی *"
              dir="ltr"
              v-model="selected2.identifierEn"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام"
              v-model="selected2.name"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="selected2.material"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="selected2.coating"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="selected2.dimensionStandard"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="selected2.diameter"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="selected2.length"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="واحد اندازه‌گیری"
              v-model="selected2.measurementUnit"
            ></v-text-field>

            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="selected2.description"
            ></v-textarea>
            <v-textarea
              outlined
              dense
              label="توضیحات فنی"
              v-model="selected2.technicalDescription"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeEditModal()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="editItem()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-col cols="12">
      <b-card header-bg-variant="secondary" header-text-variant="light">
        <template v-slot:header>
          <v-row>
            <v-col cols="12" class="mt-4">
              <h4>شرح کالا: {{ itemInfo.identifierFa }}</h4>
              <h4 dir="ltr" style="text-align: left">
                English Description: {{ itemInfo.identifierEn }}
              </h4>
              <h4>موجودی: {{ itemInfo.sum }} {{ itemInfo.measurementUnit }}</h4>
            </v-col>
          </v-row>
        </template>
        <loading v-if="vLoading" />
        <v-row>
          <v-col cols="12">
            <b-button
              class="mr-1"
              variant="success"
              style="float: left"
              @click="openEditDialog(itemInfo)"
              >ویرایش
            </b-button>
            <b-button
              class="mr-1"
              variant="warning"
              style="float: left"
              @click="openChangeInventoryDialog()"
              >رسید / حواله
            </b-button>
          </v-col>
        </v-row>
        <b-tabs pills card content-class="mt-3">
          <b-tab title="عمومی" active>
            <b-card>
              <table class="orderInfoTable" border="1px" style="width: 100%">
                <tbody>
                  <tr v-for="field in fieldsFull" :key="field.key">
                    <td style="text-align: center">
                      <strong>{{ field.label }}</strong>
                    </td>
                    <td style="text-align: center">
                      {{ itemInfo[field.key] }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center">
                      <strong>نوع کالا: </strong>
                    </td>
                    <td style="text-align: center">
                      <a
                        :href="'/warehouse/' + type.slug + 's'"
                        target="_blank"
                        >{{ type.name }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card>
          </b-tab>

          <b-tab title="کاردکس عمومی" v-if="itemInfo.allExchanges">
            <b-table
              responsive
              show-empty
              id="detailsTable"
              :items="itemInfo.allExchanges"
              :fields="allExchangesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentExchangePage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentExchangePage - 1) }}
                </div>
              </template>
              <template v-slot:cell(operation)="row">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </template>

              <template #row-details="row">
                <div
                  class="animated fadeIn"
                  style="text-align: center; vertical-align: middle"
                >
                  <b-button
                    class="mx-1"
                    variant="primary"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="submitCorrection(row.item, row.item.warehouseId)"
                    >اصلاح سند
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="success"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="approve(row.item)"
                    >تایید نهایی
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="danger"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="askDelete(row.item)"
                    >حذف تراکنش
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="warning"
                    v-if="row.item.status == 'تایید نهایی'"
                    @click="needEdit(row.item)"
                    >نیاز به اصلاح
                  </b-button>
                </div>
              </template>

              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="currentExchangePage"
              :total-rows="itemInfo.allExchanges.length"
              :per-page="ExchangePerPage"
              aria-controls="detailsTable"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-tab>

          <b-tab title="کاردکس به ازای انبار" v-if="itemInfo.exchanges">
            <b-card
              v-for="warehouse in itemInfo.exchanges"
              :key="warehouse.warehouseId"
              header-bg-variant="light"
              header-text-variant="dark"
              bg-variant="white"
            >
              <template v-slot:header>
                <h5>
                  رسید و حواله‌های کالا در انبار
                  <a
                    :href="'/warehouse/profile/' + warehouse.warehouseId"
                    target="_blank"
                  >
                    <strong>{{ warehouse.warehouseName }}</strong>
                  </a>
                </h5>
                <h6>موجودی کل در این انبار: {{ warehouse.sum }}</h6>
              </template>

              <b-table
                responsive
                show-empty
                id="detailsTable"
                :items="warehouse.allExchanges"
                :fields="exchangesFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentWarehouseExchangePage"
                :per-page="perPage"
                :busy="isBusy"
                :filter="filter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{
                      data.index +
                      1 +
                      perPage * (currentWarehouseExchangePage - 1)
                    }}
                  </div>
                </template>
                <template v-slot:cell(operation)="row">
                  <b-button
                    v-if="row.item._showDetails"
                    variant="danger"
                    @click="row.toggleDetails"
                    >بستن
                  </b-button>
                  <b-button v-else variant="primary" @click="row.toggleDetails"
                    >عملیات
                  </b-button>
                </template>

                <template #row-details="row">
                  <div
                    class="animated fadeIn"
                    style="text-align: center; vertical-align: middle"
                  >
                    <b-button
                      class="mx-1"
                      variant="primary"
                      v-if="row.item.status != 'تایید نهایی'"
                      @click="submitCorrection(row.item, warehouse.warehouseId)"
                      >اصلاح سند
                    </b-button>
                    <b-button
                      class="mx-1"
                      variant="success"
                      v-if="row.item.status != 'تایید نهایی'"
                      @click="approve(row.item)"
                      >تایید نهایی
                    </b-button>
                    <b-button
                      class="mx-1"
                      variant="danger"
                      v-if="row.item.status != 'تایید نهایی'"
                      @click="doDelete(row.item)"
                      >حذف تراکنش
                    </b-button>
                    <b-button
                      class="mx-1"
                      variant="warning"
                      v-if="row.item.status == 'تایید نهایی'"
                      @click="needEdit(row.item)"
                      >نیاز به اصلاح
                    </b-button>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <b-pagination
                v-model="currentWarehouseExchangePage"
                :total-rows="warehouse.allExchanges.length"
                :per-page="ExchangePerPage"
                aria-controls="detailsTable"
                align="center"
                size="md"
                class="my-0"
              ></b-pagination>
              <br />
            </b-card>
          </b-tab>

          <b-tab title="نمودار موجودی" v-if="itemInfo.exchanges">
            <v-row>
              <v-row>
                <v-col cols="5">
                  <b-form-group label="از تاریخ">
                    <date-picker
                      v-model="chartFrom"
                      :editable="true"
                    ></date-picker>
                  </b-form-group>
                </v-col>
                <v-col cols="5">
                  <b-form-group label="تا تاریخ">
                    <date-picker
                      v-model="chartTo"
                      :editable="true"
                    ></date-picker>
                  </b-form-group>
                </v-col>
                <v-col cols="2" class="align-middle">
                  <b-btn @click="updateChart('period')" class="btn btn-dark">
                    بروزرسانی نمودار
                  </b-btn>
                  <b-btn @click="updateChart('global')" class="btn btn-dark">
                    نمایش نمودار عمومی
                  </b-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-row>
              <v-col cols="12">
                <line-chart
                  v-if="!chartBusy"
                  :chartdata="chartData"
                  :options="chartOptions"
                >
                </line-chart>
              </v-col>
            </v-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </v-col>
    <v-dialog v-model="editExchangeModal" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش {{ selectedExchange.type }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <div dir="ltr">
            </div>
            <b-form-group
              :label="
                selectedExchange.type == 'رسید' ? 'تاریخ ورود' : 'تاریخ خروج'
              "
            >
              <date-picker v-model="edit.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group
              :label="
                selectedExchange.type == 'رسید' ? 'ساعت ورود' : 'ساعت خروج'
              "
            >
              <date-picker
                v-model="edit.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <v-select
              :label="
                selectedExchange.type == 'رسید' ? 'انبار مقصد' : 'انبار مبدا'
              "
              :items="warehouses"
              v-model="selectedExchangeWarehouse"
              outlined
              dense
              item-text="name"
              item-value="id"
              disabled
            />
            <v-text-field
              outlined
              dense
              :label="
                selectedExchange.type == 'رسید' ? 'حجم ورودی' : 'حجم خروجی'
              "
              v-model="edit.amount"
              type="number"
            ></v-text-field>
            <v-select
              v-model="edit.subType"
              dense
              outlined
              hide-details
              :label="
                selectedExchange.type == 'رسید' ? 'نوع رسید' : 'نوع حواله'
              "
              :items="
              selectedExchange.type == 'رسید' ? entryType : exitType
              "
              attach
              class="mb-3"
            >
            </v-select>
            <v-text-field
              outlined
              dense
              :label="selectedExchange.type == 'رسید' ? 'مبدا' : 'مقصد'"
              v-model="edit.orgDes"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="edit.note"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="editExchangeModal = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="editSubmit(selectedExchange)">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmDeleteDialog"
      max-width="500px"
      header-color="error"
    >
      <v-card>
        <v-card-title>
          <h4>حذف {{ selectedExchange.type }}</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <p>
              آیا از حذف {{ selectedExchange.type }} با مشخصات زیر مطمئن هستید؟
            </p>
            <p style="font-weight: bold; color: red">
              این کار غیر قابل برگشت است!
            </p>
            <b-table
              small
              responsive
              show-empty
              id="detailsTable"
              :items="[selectedExchange]"
              :fields="delExchangesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmDeleteDialog = false">
            لغو
          </v-btn>
          <v-btn
            class="text-white"
            color="red"
            @click="doDelete(selectedExchange)"
          >
            حذف کن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Axios from "axios";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { link } from "fs";
import router from "../../router";

import moment from "moment-jalaali";
import { setTimeout } from "timers";
import Loading from "../../components/Loading.vue";
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables
import LineChart from "/src/components/charts/LineExample.vue";

export default {
  data() {
    return {
      entrySelectedType: "",
      exitSelectedType: "",
      entryType: [
        {value: "رسید انتقالی میان انبارها", text: "رسید انتقالی میان انبارها"},
        {value: "رسید از تولید", text: "رسید از تولید"},
        {value: "تعدیل افزاینده موجودی انبار", text: "تعدیل افزاینده موجودی انبار"},
        {value: "رسید از خرید", text: "رسید از خرید"},
        {value: "برگشت از فروش", text: "برگشت از فروش"},
        {value: "سایر", text: "سایر"},
      ],
      exitType: [
        {value: "حواله انتقالی میان انبارها", text: "حواله انتقالی میان انبارها"},
        {value: "برگشت به تولید", text: "برگشت به تولید"},
        {value: "حواله از فروشگاه", text: "حواله از فروشگاه"},
        {value: "تعدیل کاهنده موجودی انبار", text: "تعدیل کاهنده موجودی انبار"},
        {value: "حواله مصارف تولید", text: "حواله مصارف تولید"},
        {value: "سایر", text: "سایر"},
      ],
      guide: false,
      type: Var.allTypes[0],
      itemInfo: {},
      warehouses: [],
      changeInventoryDialog: false,
      entryDialog: false,
      exitDialog: false,
      transferDialog: false,
      editDialog: false,
      entry: {},
      exit: {},
      selected2: {},
      fieldsFull: [
        { key: "identifierFa", label: "شرح فارسی" },
        { key: "identifierEn", label: "شرح انگلیسی" },
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "sum", label: "موجودی" },
        { key: "measurementUnit", label: "واحد اندازه‌گیری" },
        { key: "description", label: "توضیحات" },
        { key: "technicalDescription", label: "توضیحات فنی" },
        { key: "alertRange", label: "بازه اخطار" },
        { key: "crisisRange", label: "بازه بحران" },
        { key: "expireDate", label: "تاریخ انقضا" },
        { key: "oldId", label: "کد قدیم" },
      ],
      moment: moment,
      currentPage: 1,
      perPage: 10,
      filter: null,
      fields: [
        { key: "index", label: "#" },
        { key: "date", label: "تاریخ" },
        { key: "showName", label: "نام فایل" },
        { key: "uploaderName", label: "نام فرد آپلودکننده" },
        { key: "operation", label: "دریافت" },
      ],
      isBusy: false,
      chartBusy: true,
      role: "",
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "operation", label: "عملیات" },
      ],
      allExchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "warehouseName", label: "انبار مربوطه" },
        { key: "operation", label: "عملیات" },
      ],
      delExchangesFields: [
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "warehouseName", label: "انبار مربوطه" },
      ],
      ExchangePerPage: 10,
      currentExchangePage: 1,
      currentWarehouseExchangePage: 1,
      selectedExchange: {},
      selectedExchangeWarehouse: "",
      confirmDeleteDialog: false,
      editExchangeModal: false,
      edit: {},
      chartFrom: null,
      chartTo: null,
      chartData: {},
      chartOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "موجودی کالا در طول زمان",
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "",
                fontFamily: "iransans",
              },
              ticks: {
                min: 0,
                fontFamily: "iransans",
                // stepSize: 10,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
    };
  },
  components: {
    VueSlider,
    datePicker: VuePersianDatetimePicker,
   
    Loading,
    LineChart,
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    openChangeInventoryDialog() {
      this.changeInventoryDialog = true;
    },
    openEntryDialog() {
      this.entryDialog = true;
      this.entry = {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        time: moment(new Date()).format("HH:mm"),
      };
    },
    openExitDialog() {
      this.exitDialog = true;
      this.exit = {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        time: moment(new Date()).format("HH:mm"),
      };
    },
    openEditDialog(item) {
      this.editDialog = true;
      this.selected2 = JSON.parse(JSON.stringify(item));
    },
    closeEditModal() {
      this.editDialog = false;
    },
    updateChart(type) {
      this.chartBusy = true;
      if (type == "global") {
        Axios.post(
          this.baseUrl + "/ppkpms/warehouse/warehouseItem/transactionReport",
          {
            warehouseItemId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.chartData = res.data;
              setTimeout(() => {
                this.chartBusy = false;
              }, 1000);
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
          });
      } else if (type == "period") {
        Axios.post(
          this.baseUrl + "/ppkpms/warehouse/warehouseItem/transactionReport",
          {
            warehouseItemId: this.$route.params.id,
            startDate: this.chartFrom,
            endDate: this.chartTo,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.chartData = res.data;
              setTimeout(() => {
                this.chartBusy = false;
              }, 1000);
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
          });
      }
    },
    entrySubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/entranceProduct",
        {
          warehouseItemId: this.$route.params.id,
          warehouseSectionId: this.entry.warehouse,
          amount: this.entry.number,
          date: this.entry.date + " " + this.entry.time,
          orgDes: this.entry.origin,
          note: this.entry.description,
          subType: this.entrySelectedType,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.entryDialog = false;
            this.entry = {};
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/exitProduct",
        {
          warehouseItemId: this.$route.params.id,
          warehouseSectionId: this.exit.warehouse,
          amount: this.exit.number,
          date: this.exit.date + " " + this.exit.time,
          orgDes: this.exit.origin,
          note: this.exit.description,
          subType: this.exitSelectedType,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.exitDialog = false;
            this.exit = {};
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    editItem() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.$route.params.id,
          name: this.selected2.name,
          identifierFa: this.selected2.identifierFa,
          identifierEn: this.selected2.identifierEn,
          description: this.selected2.description,
          technicalDescription: this.selected2.technicalDescription,
          material: this.selected2.material,
          coating: this.selected2.coating,
          dimensionStandard: this.selected2.dimensionStandard,
          diameter: this.selected2.diameter,
          length: this.selected2.length,
          place: this.selected2.place,
          suppliersList: this.selected2.suppliersList,
          expireDate: this.selected2.expireDate,
          measurementUnit: this.selected2.measurementUnit,
          alertRange: this.selected2.alertRange,
          crisisRange: this.selected2.crisisRange,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editDialog = false;
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getWarehouses() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseSections/getAll",
        {
          warehouseTypeId: this.type.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.warehouses = res.data;
            this.warehouses = this.warehouses.sort((a, b) =>
              a.name > b.name ? 1 : -1
            );
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getItemInfo() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/getInfo",
        {
          warehouseItemId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.itemInfo = res.data;
            this.vLoading = false;
            this.isBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.isBusy = false;
          this.toast(err.response.data, "error");
        });
    },
    submitCorrection(exchange, warehouseId) {
      this.selectedExchange = exchange;
      this.selectedExchangeWarehouse = warehouseId;
      this.editExchangeModal = true;
      this.edit = JSON.parse(JSON.stringify(exchange));
      try {
        let myDateTime = this.edit.date.split(" ");
        this.edit.date = myDateTime[0];
        this.edit.time = myDateTime[1];
      } catch (error) {
        this.edit.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.edit.time = moment(new Date()).format("HH:mm");
      }
    },
    editSubmit(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/editTransaction",
        {
          transactionId: exchange.id,
          amount: this.edit.amount,
          date: this.edit.date + " " + this.edit.time,
          orgDes: this.edit.orgDes,
          note: this.edit.note,
          subType: this.edit.subType,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("تایید با موفقیت انجام شد", "success");
            this.getItemInfo();
            this.editExchangeModal = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    approve(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/confirmation",
        {
          transactionId: exchange.id,
          amount: exchange.amount,
          date: exchange.date + " " + exchange.time,
          orgDes: exchange.orgDes,
          note: exchange.note,
          subType: exchange.subType,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("تایید با موفقیت انجام شد", "success");
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    askDelete(exchange) {
      this.selectedExchange = exchange;
      this.confirmDeleteDialog = true;
    },
    doDelete(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/delete",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("حذف با موفقیت انجام شد", "success");
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.getItemInfo();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.getItemInfo();
        });
    },
    needEdit(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/needEdit",
        {
          transactionId: exchange.id,
          amount: exchange.amount,
          date: exchange.date + " " + exchange.time,
          orgDes: exchange.orgDes,
          note: exchange.note,
          subType: exchange.subType,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("ویرایش با موفقیت انجام شد", "success");
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.isBusy = true;
    this.vLoading = true;
    this.role = localStorage.getItem("role");
    this.updateChart("global");
    this.getWarehouses();
    this.getItemInfo();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.orderInfoTable {
  border-radius: unset;
}
</style>
